import React from "react";

const legalLinks = [
  { t: "Impressum", h: "https://luisabergholz.com/impressum", id: "impressum" },
  { t: "Datenschutz", h: "https://luisabergholz.com/datenschutzerklaerung", id: "datenschutz" },
  { t: "AGB", h: "https://luisabergholz.com/agb", id: "agb" },
  { t: "Vertrag widerrufen", h: "https://luisabergholz.com/widerrufsformular", id: "widerruf" },
];

export default function SiteFooter() {
  return (
    <footer data-testid="footer" className="bg-espresso-2 py-10 pb-28 text-center md:pb-10">
      <p className="mb-6 font-heading text-xs uppercase tracking-[0.35em] text-gold/70">
        by Luisa Bergholz
      </p>
      <div className="mb-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 px-6 md:gap-8">
        {legalLinks.map((l) => (
          <a
            key={l.id}
            href={l.h}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`footer-${l.id}-link`}
            className="inline-flex min-h-[44px] items-center py-2 font-heading text-xs uppercase tracking-[0.25em] text-gold/60 transition-colors duration-300 hover:text-gold"
          >
            {l.t}
          </a>
        ))}
      </div>
      <p className="font-heading text-xs font-600 uppercase tracking-[0.35em] text-gold/70" style={{ fontWeight: 600 }}>
        © 2026 Luisa Bergholz. Alle Rechte vorbehalten.
      </p>
    </footer>
  );
}
